import { CardModel } from './card.model';

export class PaginaCardsModel {

    constructor(
        public titulo?: string,
        public icone?: string,
        public cardList?: CardModel[],
    ) {
        this.cardList = [];
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/pagina-cards.model.ts